var map = {
	"./ach.png": "2ecf",
	"./bakery-old.svg": "7e79",
	"./braintree.svg": "2b1c",
	"./conekta.svg": "d9d7",
	"./dupay.svg": "0e0f",
	"./getnet.svg": "b188",
	"./mercadopago.svg": "d1ac",
	"./niubiz.png": "a772",
	"./nmi.png": "30b4",
	"./pagarme-current.svg": "213c",
	"./pagarme.svg": "d691",
	"./payments-way.png": "9795",
	"./paypal.svg": "71d2",
	"./payu.svg": "1562",
	"./placetopay.png": "ba7b",
	"./stripe.svg": "8bcf",
	"./transbank.jpg": "f353",
	"./unicef.svg": "82f9",
	"./visanet.png": "466b",
	"./wompi.svg": "a62e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3842";